import React from 'react';
import useSiteMetadata from './useContentfulSiteMetadata';
import MTVFontBook from '../style/fonts/FyranSans-Regular.woff2';
import MTVFontCore from '../style/fonts/FyranSans-Regular.woff2';
import MTVFontBookItalic from '../style/fonts/FyranSans-Regular.woff2';
import MTVFontSemiBold from '../style/fonts/FyranSans-Medium.woff2';
import MTVFontSemiBoldItalic from '../style/fonts/FyranSans-Medium.woff2';
import MTVFontWebExtraBold from '../style/fonts/FyranSans-Medium.woff2';
import { CONSENT_CATEGORY_Välttämättömät, CONSENT_CATEGORY_Kohdistaminen, useConsent } from "../utils/cookie-consent";

const Seo = ({ title, description, path, type, published, publicURL, imageURL }) => {
  
  const data = useSiteMetadata();

  const commonMetadata =
    data.commonMetadata.nodes.length > 0 ? data.commonMetadata.nodes[0] : {};

    return (<>
        <html lang="fi" />
        <title>{title || commonMetadata.siteTitlePrefix}</title>
        <link
          key="font-001"
          rel="preload"
          as="font"
          href={MTVFontBook}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          key="font-002"
          rel="preload"
          as="font"
          href={MTVFontCore}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          key="font-003"
          rel="preload"
          as="font"
          href={MTVFontBookItalic}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          key="font-004"
          rel="preload"
          as="font"
          href={MTVFontSemiBold}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          key="font-005"
          rel="preload"
          as="font"
          href={MTVFontSemiBoldItalic}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          key="font-006"
          rel="preload"
          as="font"
          href={MTVFontWebExtraBold}
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <meta key="meta-001" name="description" content={description} />
        <meta key="meta-002" name="theme-color" content={commonMetadata.themeColor} />
        <meta key="meta-003" name="twitter:card" content={commonMetadata.twitterCardType} />
        <meta key="meta-004" name="twitter:site" content={commonMetadata.twitterHandle}  />
        <meta key="meta-005" name="twitter:title" content={title}  />
        <meta key="meta-006" name="twitter:description" content={description}  />
        <meta key="meta-007" name="twitter:image" content={imageURL || `${commonMetadata.siteBaseUrl}${publicURL || commonMetadata.socialMediaImage.localFile?.publicURL || ''}`}  />
        <meta key="meta-008" name="google-site-verification" content={commonMetadata.googleSiteVerification}  />
        <meta key="meta-009" property="fb:app_id" content={commonMetadata.facebookAppId} />
        <meta key="meta-010" property="article:section" content={commonMetadata.openGraphArticleSection}  />
        <meta key="meta-011" property="article:published_time" content={published}  />
        <meta key="meta-012" prefix="og: http://ogp.me/ns#" property="og:url" content={`${commonMetadata.siteBaseUrl}${path}`}  />
        <meta key="meta-013" property="og:description" content={description}  />
        <meta key="meta-014" prefix="og: http://ogp.me/ns#" property="og:type" content={`${type ? type : 'website'}`} />
        <meta key="meta-015" property="og:site_name" content={commonMetadata.siteName}  />
        <meta key="meta-016" prefix="og: http://ogp.me/ns#" property="og:title" content={title}  />
        <meta key="meta-017" prefix="og: http://ogp.me/ns#" property="og:image" content={imageURL || `${commonMetadata.siteBaseUrl}${publicURL || commonMetadata.socialMediaImage.localFile?.publicURL || ''}`}  />
        <meta key="meta-018" property="lp:image" content={imageURL || `${commonMetadata.siteBaseUrl}${publicURL || commonMetadata.socialMediaImage.localFile?.publicURL || ''}`}  />
        
        <BodyCookieConsentScripts />
      </>
    )
  }
  
/** Embed scripts and other tags that require certain cookie consent levels */
const BodyCookieConsentScripts = () => {
  const hasConsentVälttämättömät = useConsent(CONSENT_CATEGORY_Välttämättömät);
  const hasConsentKohdistaminen  = useConsent(CONSENT_CATEGORY_Kohdistaminen);
  return (
      <>
          {/** Salesforce Pradot */}
          { process.env.NODE_ENV === 'production' && hasConsentVälttämättömät &&
            <>
              <script key="script-001" dangerouslySetInnerHTML={{__html:`
                piAId = '996252';
                piCId = '1043';
                piHostname = 'pi.pardot.com';

                (function() {
                  function async_load(){
                    var s = document.createElement('script'); s.type = 'text/javascript';
                    s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
                    var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
                  }
                  if(window.attachEvent) { window.attachEvent('onload', async_load); }
                  else { window.addEventListener('load', async_load, false); }
                })();
              `}}/>
            </>
          }
          {/** Adform */}
          { process.env.NODE_ENV === 'production' && hasConsentKohdistaminen &&
              <img key="script-002" src="https://track.adform.net/Serving/TrackPoint/?pm=788946&lid=81913298" width="1" height="1" alt="" />
          }
      </>
  )
}

export default Seo;
